<div class="material-orders w-full">
  @if (loading) {
    <div class="loading-spinner flex mt-10 justify-center">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    <div class="container-table">
      <div class="top-bar-table">
        <div class="search-bar">
          <div class="search-wrapper">
            <mat-form-field>
              <div class="custom-icon search">search icon</div>
              <input
                matInput
                id="orders-table-search"
                [(ngModel)]="query"
                (keyup)="triggerSearch()"
                placeholder="Search"
                autocomplete="off"
              />
            </mat-form-field>
            <div class="search-spinner">
              @if (searchLoading) {
                <mat-spinner [diameter]="20"></mat-spinner>
              }
            </div>
            <div class="mobile-buttons">
              <app-csv-download
                [csvData]="getOrderCsvData()"
                [fileName]="csvDownloadFileName"
              ></app-csv-download>
            </div>
          </div>
        </div>

        <div class="action-buttons">
          <span>Download</span>
          <app-csv-download
            [csvData]="getOrderCsvData()"
            [fileName]="csvDownloadFileName"
          ></app-csv-download>
        </div>
      </div>

      <div class="filter-display">
        <ul class="filter-active">
          @for (filter of filterService; track filter.attrs.label) {
            <li>
              <span>Service: {{ filter.attrs.label }}</span>
              <mat-icon (click)="removeThis('service', filter)"
                >cancel</mat-icon
              >
            </li>
          }
          @for (filter of filterStatus; track filter.attrs.label) {
            <li>
              <span>Status: {{ filter.attrs.label }}</span>
              <mat-icon (click)="removeThis('status', filter)">cancel</mat-icon>
            </li>
          }
          @for (filter of filterAddress; track filter.attrs.label) {
            <li>
              <span>Address: {{ filter.attrs.label }}</span>
              <mat-icon (click)="removeThis('address', filter)"
                >cancel</mat-icon
              >
            </li>
          }
        </ul>
      </div>

      <table
        mat-table
        multiTemplateDataRows
        matSort
        [dataSource]="dataSource"
        class="mat-elevation-z0"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef># ID</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="deal">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Deal</th>
          <td mat-cell *matCellDef="let element">{{ element.deal }}</td>
        </ng-container>

        <ng-container matColumnDef="oli">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>OLI</th>
          <td mat-cell *matCellDef="let element">{{ element.oli }}</td>
        </ng-container>

        <ng-container matColumnDef="line_type">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Order Type</th>
          <td mat-cell *matCellDef="let element">{{ element.line_type }}</td>
        </ng-container>

        <ng-container matColumnDef="nit">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>NIT</th>
          <td mat-cell *matCellDef="let element">{{ element.nit }}</td>
        </ng-container>

        <ng-container matColumnDef="site">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Site</th>
          <td mat-cell *matCellDef="let element">{{ element.site }}</td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Address</th>
          <td mat-cell *matCellDef="let element">{{ element.address }}</td>
        </ng-container>

        <ng-container matColumnDef="city">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>City</th>
          <td mat-cell *matCellDef="let element">{{ element.city }}</td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>State</th>
          <td mat-cell *matCellDef="let element">{{ element.state }}</td>
        </ng-container>

        <ng-container matColumnDef="service">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Service</th>
          <td mat-cell *matCellDef="let element">{{ element.service }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.status }}</td>
        </ng-container>

        <ng-container matColumnDef="foc_date">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>FOC Date</th>
          <td mat-cell *matCellDef="let element">{{ element.foc_date }}</td>
        </ng-container>

        <ng-container matColumnDef="expands">
          <th mat-header-cell *matHeaderCellDef>
            @if (allExpanded) {
              <mat-icon aria-label="Hide all" (click)="toggleExpandAll()"
                >keyboard_arrow_up</mat-icon
              >
            } @else {
              <mat-icon aria-label="Expand all" (click)="toggleExpandAll()"
                >keyboard_arrow_down</mat-icon
              >
            }
          </th>
          <td mat-cell *matCellDef="let element">
            @if (element.expanded) {
              <mat-icon aria-label="Expand">keyboard_arrow_up</mat-icon>
            } @else {
              <mat-icon aria-label="Expand">keyboard_arrow_down</mat-icon>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="orderColumns.length"
            [ngClass]="{ 'open-td': element.expanded }"
          >
            <div
              class="extended-row-detail"
              [@detailExpand]="element.expanded ? 'expanded' : 'collapsed'"
            >
              <app-extended-row
                class="extended-component"
                [order]="element.full_order"
                (openOrder)="openOrder($event)"
              ></app-extended-row>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="orderColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: orderColumns"
          class="basic-row"
          (click)="row.expanded = !row.expanded"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="extended-row"
        ></tr>
      </table>

      <mat-paginator
        #paginatorElement
        [pageSizeOptions]="pageSizeOptions"
        (page)="setSelectValueToAll()"
        (click)="setOptionLabelToAll()"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
  }
</div>
